import { SubmittedCase } from 'types/case';
import { Brand } from '@hbo/ui-servicing-react-components';

import client from './client';

export namespace CaseTrackingService {
  export enum CustomStatusCode {
    Error = 451
  }
  export async function getCaseByMortgageReferenceByToken() {
    const { data } = await client.get<SubmittedCase>(
      `/mortgages/v1/case-tracking/application/track`
    );
    return data;
  }
}
